import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/bq-store/inventory/product-group",
        component: List,
        name: "bq-store.inventory.product.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/inventory/product-group/create",
        component: Create,
        name: "bq-store.inventory.product.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/bq-store/inventory/product-group/:id/edit",
        component: Edit,
        name: "bq-store.inventory.product.group.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
